
var path = "https://www.pakdisco.com/";
//var path = "http://192.168.1.76:2037/";
export default {
    ApiRoot: path,
    ApiUrl: path + "DesktopModules/PakdisSurvey/API/PakdisSurvey/"
}



// WEBPACK FOOTER //
// ./src/config.jsx